import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

import { AlertService } from '../../../../../core/services/alert.service';
import { AuthGuardService } from '../../../../../core/services/auth/auth-guard.service';
import { I18nService } from '../../../../../core/services/i18n.service';
import { AnchorComponent } from '../../../../../shared/components/anchor/anchor.component';
import { AuthModalService } from '../../../../../shared/components/modals/auth-modal/auth-model.service';
import { InputPasswordComponent } from '../../../../../shared/modules/inputs/components/password/password.component';
import { RecaptchaComponent } from '../../../../../shared/modules/inputs/components/recaptcha/recaptcha.component';
import { InputTextComponent } from '../../../../../shared/modules/inputs/components/text/text.component';
import { OpenidAuthenticationComponent } from '../../components/openid-authentication/openid-authentication.component';
import { AuthService } from '../../services/auth.service';
import { VerifyEmailService } from '../../services/verify-email.service';
import { buildForm } from './form';
import { SharedModule } from '../../../../../shared/shared-module';
import { TranslateService } from '../../../../../shared/modules/translate/translate.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [
    ReactiveFormsModule,
    OpenidAuthenticationComponent,

    AnchorComponent,
    InputTextComponent,
    InputPasswordComponent,
    SharedModule,
    RecaptchaComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  form = buildForm();
  isShowErrors = false;
  constructor(
    private verifyEmailService: VerifyEmailService,
    private router: Router,
    private authGuardService: AuthGuardService,
    public authModalService: AuthModalService,
    private alertService: AlertService,
    private userService: AuthService,
    // private i18nService: I18nService,
    // private translationService: TranslateService,
  ) { }

  async submit() {
    if (this.form.invalid) {
      this.isShowErrors = true;
      return;
    }
    this.isShowErrors = false;

    const res = await this.userService.login(this.form.value);

    this.alertService.suucess(res.message);

    if (res.result.verifyEmail) {
      this.verifyEmailService.email = res.result.user.email as any;

      if (this.authModalService.isInModal) {
        this.authModalService.goVerifyEmail();
      } else {
        this.router.navigateByUrl('/verify-email');
      }
      return;
    }
    this.authGuardService.setUserToken(res.result);

    if (this.authModalService.isInModal) {
      this.authModalService.close();
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
